<!-- eslint-disable vue/require-v-for-key -->
<template>
    <div>
        <vue-headful :title="$t('my-study-plan')" />

        <div class="mb-3">
            <multiselect
                v-model="studyPlanActive"
                class="speciality_select"
                :options="studyPlan"
                selectedLabel="Выбрано"
                :placeholder="$t('speciality')"
                :custom-label="nameSpeciality"
                @remove="multiselectRemove"
                @select="multiselectAction"
                :allowEmpty="false"
                :loading="loading"
                deselectLabel=""
                selectLabel=""
                track-by="uid">
            </multiselect>
        </div>

        <!-- Информация о студенте -->
        <vs-collapse v-if="studyPlanActive" class="vx-card mb-5">
            <vs-collapse-item>
                <h4 slot="header">
                    {{ $t('my-study-plan') }}
                </h4>

<!--        <vx-card v-if="studyPlanActive" :title="$t('my-study-plan')" class="mb-5">-->
            <div class="plan_info">
                <div class="item lg:flex items-center" v-if="studyPlanActive.preparation_level">
                    <div class="label text-sm md:text-base lg:text-base xl:text-base">{{$t('training_level')}}:</div>
                    <div class="val">{{ studyPlanActive.preparation_level }}</div>
                </div>
                <div class="item lg:flex items-center" v-if="studyPlanActive.study_form">
                    <div class="label text-sm md:text-base lg:text-base xl:text-base">{{$t('form_of_training')}}:</div>
                    <div class="val">{{ studyPlanActive.study_form }}</div>
                </div>
                <div class="item lg:flex items-center" v-if="studyPlanActive.faculty&&!this.GET_SCHEDULE.use_schedule">
                    <div class="label text-sm md:text-base lg:text-base xl:text-base">{{$t('faculty')}}:</div>
                    <div class="val">{{ studyPlanActive.faculty }}</div>
                </div>
                <div class="item lg:flex items-center" v-if="studyPlanActive.cathedra">
                    <div class="label text-sm md:text-base lg:text-base xl:text-base">{{!this.GET_SCHEDULE.use_schedule ? $t('cathedra'): $t('department')}}:</div>
                    <div class="val">{{ studyPlanActive.cathedra }}</div>
                </div>
                <div class="item lg:flex items-center" v-if="studyPlanActive.speciality">
                    <div class="label text-sm md:text-base lg:text-base xl:text-base">{{$t('direction_of_preparation')}}:</div>
                    <div class="val">{{ studyPlanActive.speciality }}</div>
                </div>
                <div class="item lg:flex items-center" v-if="studyPlanActive.education_program && studyPlanActive.education_program.group">
                    <div class="label text-sm md:text-base lg:text-base xl:text-base">{{$t('gop')}}:</div>
                    <div class="val">{{ studyPlanActive.education_program.group.code }} - {{ studyPlanActive.education_program.group.name }}</div>
                </div>
                <div class="item lg:flex items-center" v-if="studyPlanActive.education_program">
                    <div class="label text-sm md:text-base lg:text-base xl:text-base">{{!this.GET_SCHEDULE.use_schedule ? $t('educational_program') : $t('direction')}}:</div>
                    <div class="val">{{ studyPlanActive.education_program.code }} - {{ studyPlanActive.education_program.name }}</div>
                </div>
                <div class="item lg:flex items-center" v-if="studyPlanActive.trajectory ">
                    <div class="label text-sm md:text-base lg:text-base xl:text-base">{{$t('learning_trajectory')}}:</div>
                    <div class="val">{{ studyPlanActive.trajectory }}</div>
                </div>
                <div class="item lg:flex items-center" v-if="studyPlanActive.study_period ">
                    <div class="label text-sm md:text-base lg:text-base xl:text-base">{{$t('period_of_study')}}:</div>
                    <div class="val">{{ studyPlanActive.study_period }}</div>
                </div>
                <div class="item lg:flex items-center" v-if="studyPlanActive.on_base ">
                    <div class="label text-sm md:text-base lg:text-base xl:text-base">{{$t('previous_education')}}:</div>
                    <div class="val">{{ studyPlanActive.on_base }}</div>
                </div>
                <div class="item lg:flex items-center" v-if="studyPlanActive.language ">
                    <div class="label text-sm md:text-base lg:text-base xl:text-base">{{$t('study_language')}}:</div>
                    <div class="val">{{ studyPlanActive.language }}</div>
                </div>
                <div class="item lg:flex items-center" v-if="studyPlanActive.group ">
                    <div class="label text-sm md:text-base lg:text-base xl:text-base">{{$t('eduGroup')}}:</div>
                    <div class="val">{{ studyPlanActive.group }}</div>
                </div>
                <div class="item lg:flex items-center" v-if="studyPlanActive.education_base && !this.GET_SCHEDULE.use_schedule">
                    <div class="label text-sm md:text-base lg:text-base xl:text-base">{{$t('basis_for_admission')}}:</div>
                    <div class="val">{{ studyPlanActive.education_base }}</div>
                </div>
            </div>
<!--        </vx-card>-->
            </vs-collapse-item>
        </vs-collapse>
        <!-- Таблица дисциплин -->
        <vx-card :title="$t('disciplines_2')" v-if="discipline.length">
            <div class="mb-3 lg:flex item-center justify-between">
                <vs-button size="small" @click="collapseToggle()" color="primary" type="filled">{{collapseBtnText}}</vs-button>
                <div class="mt-2 lg:mt-0 text-xs md:text-base lg:text-base xl:text-base">
                    {{$t('total_credit')}} {{totalCredit}}
                </div>
            </div>
            <vs-collapse type="margin" ref="mainCollapse" class="py-0 px-0 dis_collapse col_margin">
                <vs-collapse-item :open="openCollapse" v-for="(item, index) in discipline" :key="`d_${ index }`">
                    <div slot="header">
                        <div class="lg:flex pr-6 justify-between">
                            <strong class="text-sm md:text-base lg:text-base xl:text-base">{{item.name_period}}</strong>
                            <div class="text-xs md:text-base lg:text-base xl:text-base">{{$t('amount_of_credits')}}: {{ item.count_credits }}</div>
                        </div>
                    </div>

                    <div class="flex mb-2 py-3 px-4 collapse_headers text-sm md:text-base lg:text-base xl:text-base col_margin">
                        <div class="w-1/3 break-all">{{$t('discipline')}}</div>
                        <div class="w-1/3 text-center">{{$t('credit')}}</div>
                        <div class="w-1/3 text-center">{{$t('form_of_control')}}</div>
                    </div>

                    <vs-collapse ref="childCollapse" type="border" class="child_collapse col_margin mb-2" v-for="(dis, index) in item.disciplines" :key="`d_c_${ index }`">
                        <vs-collapse-item notArrow class="my-0 mx-0 shadow-none overscroll-y-auto" >
                            <div slot="header">
                                <div class="flex text-sm md:text-base lg:text-base xl:text-base">
                                    <div class="w-1/3 text-primary break-all">{{dis.name}}</div>
                                    <div class="w-1/3 text-center">{{ dis.load_types[0].credit_obj.credit }}</div>
                                    <div class="w-1/3 text-center">
                                        <template v-for="(form, formIndex) in dis.load_types[0].credit_obj.control_form">
                                            <span v-if="$route.params.lang == 'en'" :key="formIndex" class="formName">{{ form.control_form__name_en }}</span>
                                            <span v-if="$route.params.lang == 'ru'" :key="formIndex" class="formName">{{ form.control_form__name }}</span>
                                            <span v-if="$route.params.lang == 'kk'" :key="formIndex" class="formName">{{ form.control_form__name_kk }}</span>
                                        </template>
                                    </div>


                                </div>
                            </div>

                            <vs-table :data="dis.load_types" class="col_margin">
                                <template slot="thead">
                                    <vs-th>{{$t('activity_type')}}</vs-th>
                                    <vs-th>{{$t('study_language')}}</vs-th>
                                    <vs-th>{{$t('teacher')}}</vs-th>
                                    <vs-th>{{$t('hours')}}</vs-th>
                                </template>

                                <template slot-scope="{data}">
                                    <vs-tr :key="`t_${ indextr }`" v-for="(tr, indextr) in data">
                                        <vs-td  style="width: 50%" :data="data[indextr].load_type">
                                            {{ data[indextr].load_type }}
                                        </vs-td>
                                        <vs-td style="width: 20%" :data="data[indextr].language">
                                            {{ data[indextr].language }}
                                        </vs-td>
                                        <vs-td style="width: 20%" :data="data[indextr].teacher">
                                            {{ data[indextr].teacher }}
                                        </vs-td>
                                        <vs-td style="width: 20%" :data="data[indextr].hours">
                                            {{ data[indextr].hours }}
                                        </vs-td>
                                    </vs-tr>
                                </template>
                            </vs-table>
                        </vs-collapse-item>
                        <vs-collapse-item notArrow class="my-0 mx-0 shadow-none overscroll-y-auto tr-table-state-primary"  style="background-color: #f0f8ff;" v-if="dis.alter" v-for="(dis_alter, index) in dis.alter" :key="`d_alter_c_${ index }`">
                            <div slot="header">
                                <div class="flex text-sm md:text-base lg:text-base xl:text-base">
                                    <div class="w-1/3 text-primary break-all">{{dis_alter.name}}</div>
                                    <div class="w-1/3 text-center">{{ dis_alter.load_types[0].credit_obj.credit }}</div>
                                    <div class="w-1/3 text-center">
                                        <template v-for="(dis_alter_form, dis_alter_form_formIndex) in dis_alter.load_types[0].credit_obj.control_form">
                                            <span v-if="$route.params.lang == 'en'" :key="dis_alter_form_formIndex" class="formName">{{ dis_alter_form.control_form__name_en }}</span>
                                            <span v-if="$route.params.lang == 'ru'" :key="dis_alter_form_formIndex" class="formName">{{ dis_alter_form.control_form__name }}</span>
                                            <span v-if="$route.params.lang == 'kk'" :key="dis_alter_form_formIndex" class="formName">{{ dis_alter_form.control_form__name_kk }}</span>
                                        </template>
                                    </div>
                                </div>
                            </div>

                            <vs-table :data="dis_alter.load_types" class="col_margin vs-table-primary" style="background: #f0f8ff;">
                                <template slot="thead" style="background-color: rgb(84,93,167)">
                                    <vs-th class="tr-table-state-primary">{{$t('activity_type')}}</vs-th>
                                    <vs-th class="tr-table-state-primary">{{$t('study_language')}}</vs-th>
                                    <vs-th class="tr-table-state-primary">{{$t('teacher')}}</vs-th>
                                    <vs-th class="tr-table-state-primary">{{$t('hours')}}</vs-th>
                                </template>

                                <template slot-scope="{data}" class="tr-table-state-primary" >
                                    <vs-tr :key="`t_${ indextr }`" v-for="(tr, indextr) in data" class="tr-table-state-primary" state="tr-table-state-primary">
                                        <vs-td  style="width: 50%" :data="data[indextr].load_type">
                                            {{ data[indextr].load_type }}
                                        </vs-td>
                                        <vs-td style="width: 20%" :data="data[indextr].language">
                                            {{ data[indextr].language }}
                                        </vs-td>
                                        <vs-td style="width: 20%" :data="data[indextr].teacher">
                                            {{ data[indextr].teacher }}
                                        </vs-td>
                                        <vs-td style="width: 20%" :data="data[indextr].hours">
                                            {{ data[indextr].hours }}
                                        </vs-td>
                                    </vs-tr>
                                </template>
                            </vs-table>
                        </vs-collapse-item>
                    </vs-collapse>
                </vs-collapse-item>
            </vs-collapse>
        </vx-card>

        <!-- В этот див выводил лоадер -->
        <div id="infinite_loader" class="vs-con-loading__container"></div>
        <StudyPlanApplications/>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import StudyPlanApplications from "@/pages/Home/MyStudyPlan/StudyPlanApplications";

export default {
    components: { StudyPlanApplications },
    data() {
        return {
            studyPlan: [],
            studyPlanActive: null,
            discipline: [],
            loading: false,
            openCollapse: false,
            collapseBtnText: this.$t('expand_all'),
            totalCredit: 0
        }
    },
    created: function() {
        // Запрашиваем уч план
        this.fetchStudyPlan()
    },
    computed:{
        ...mapGetters({
            GET_SCHEDULE: 'system_settings/GET_SCHEDULE'
        }),
        totolCredit(){

        }
    },
    methods: {
        ...mapActions({
            STUDY_PLAN_APPLICATIONS:'system_settings/STUDY_PLAN_APPLICATIONS',
        }),
        collapseToggle() {
            const mainCollapse = this.$refs['mainCollapse']
            const childCollapse = this.$refs['childCollapse']
            if(this.openCollapse) {
                this.openCollapse = false
                this.collapseBtnText = this.$t('expand_all')
                mainCollapse.closeAllItems(mainCollapse)

                if(childCollapse.length)
                    childCollapse.forEach(item => {
                        item.closeAllItems(item)
                    })
            } else {
                this.openCollapse = true
                this.collapseBtnText = this.$t('collapse_all')
                mainCollapse.openAllItems(mainCollapse)

                if(childCollapse.length)
                    childCollapse.forEach(item => {
                        item.openAllItems(item)
                    })
            }
        },
        nameSpeciality: data => data.education_program.name,
        multiselectRemove() {
            // Событие удаление опции из выпадающего осписка
            this.studyPlanActive = null
            this.discipline = []
        },
        async multiselectAction(item) {
            // Событие выбора опции из выпадающего списка

            this.studyPlanActive = item
            await this.fetchDiscipline(item.uid)

            await this.STUDY_PLAN_APPLICATIONS({...this.$route.query, 'study_plan': item.uid})
        },
        async fetchStudyPlan() {
            // Запрашиваем учебный план
            try {
                this.$vs.loading({
                    scale: 0.45
                })
                this.loading = true
                const {data} = await this.$http.get(`/user/my_study_plans_version2/`, {params: this.$route.query})

                this.studyPlan = data
                this.studyPlanActive = data[0]
                const url = new URL(window.location.href);
                url.searchParams.set('study_plan',  data[0].uid )
                history.pushState({}, "", url);

                // Запрашиваем таблицу дисциплин
                this.fetchDiscipline(this.studyPlanActive.uid)

                await this.STUDY_PLAN_APPLICATIONS({
                    'study_plan': url.searchParams.get('study_plan' ),
                    'uid': url.searchParams.get('uid'),
                })
            } catch(e) {
                console.log(e);
                this.$vs.notify({
                    text: this.$t('error_upload_admin'),
                    color: 'danger'
                })
            } finally {
                this.loading = false
                this.$vs.loading.close()
            }
        },
        async fetchDiscipline(uid) {
            // Запрашиваем таблицу дисциплин
            try {
                this.$vs.loading({
                    container: '#infinite_loader',
                    scale: 0.6
                })

                const {data} = await this.$http.get('/user/student/all_discipline/', { params: { study_plan: uid } })

                // Подганяем таблицу для вывода
                let disciplineArray = data.data.map(period => {

                    let list_disciplines = []
                    let disciplines = []
                    let count_cred = 0

                    period.disciplines.forEach((discipline, index, array) => {
                        if (!list_disciplines.some(dis => discipline.discipline === dis)) {
                            if (discipline.main_discipline == null){
                                var alter = []
                                var alter_list_disciplines = []
                                period.disciplines.forEach((obj, obj_index, obj_array)=>{
                                    if (!alter_list_disciplines.some(dis_obj => obj.discipline === dis_obj)) {
                                        alter_list_disciplines.push(obj.discipline)
                                        if(obj.main_discipline == discipline.discipline_uid){
                                            alter.push({
                                                load_types: obj_array.filter(dis => obj.discipline === dis.discipline),
                                                name: obj.discipline,
                                            })
                                        }
                                    }
                                })

                                list_disciplines.push(discipline.discipline)
                                count_cred = count_cred + parseInt(discipline.credit_obj.credit)
                                disciplines.push({
                                    load_types: array.filter(dis => discipline.discipline === dis.discipline),
                                    name: discipline.discipline,
                                    alter: alter,
                                })
                            }
                        }
                    });
                    // console.log(disciplines)
                    this.totalCredit = this.totalCredit + count_cred
                    this.totalCredit = parseInt(this.totalCredit)
                    return {
                        name_period: period.name_period,
                        count_credits: count_cred,
                        disciplines,
                    }
                })

                console.log('disciplineArray',disciplineArray, 'this.discipline', this.discipline);
                this.discipline = disciplineArray
                //console.log(this.discipline)
            } catch(e) {
                this.$vs.notify({
                    text: this.$t('error'),
                    color: 'danger'
                })
            } finally {
                this.$vs.loading.close('#infinite_loader > .con-vs-loading')
            }
        }
    }
}
</script>

<style lang="scss">


.open-item > .vs-collapse-item--content {
       max-height: 100% !important;
    }


.speciality_select{
    .multiselect__single{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}
.collapse_headers{
    background: #0000000a;
    border-radius: 8px;
}
.dis_collapse{
    .open-item > .vs-collapse-item--content{
        max-height: 100% !important;
    }
}
.formName:not(:first-child)::before {
    content: ', ';
}
@media only screen and (min-width: 901px) {
    .speciality_select{
        max-width: 300px;
    }
}
@media only screen and (max-width: 900px) {
    .col_margin{
        margin-left: -14px;
        margin-right: -14px;
    }
}
</style>

<style scoped lang="scss">
.plan_info{
    .item{
        &:not(:last-child){
            margin-bottom: 13px;
            padding-bottom: 13px;
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        }
        .label{
            font-weight: bold;
            padding-right: 10px;
            min-width: 250px;
        }
    }
}
#infinite_loader{
    padding: 20px 0;
    .con-vs-loading{
        background: transparent;
    }
}
</style>
